import useLazyI18next from '@wix/da-i18next/pkg/useLazyI18next';
import { i18nNamespace } from '../constants';
export default function useAdoptsI18next() {
    useLazyI18next(i18nNamespace, (language, namespace, callback)=>{
        import(`../assets/locale/messages_${language}.json`).then((resources)=>{
            callback(null, resources);
        }).catch((error)=>{
            callback(error, null);
        });
    });
}

//# sourceMappingURL=useAdoptsI18next.js.map